import { useSelector } from "react-redux";
import TickIcon from "../../../assets/images/registrationtype/tickIcon.svg";

const RegistrationCard = ({ image, label, isSelected, onClick }) => {
  const isMobile = useSelector((state) => {
    return state.systemReducer.isMobile;
  });

  return (
    <div
      className={`p-2 mx-3 ${isSelected && "selected-registration-type"} ${
        isMobile ? "registration-type-card-sm" : "registration-type-card"
      }`}
      onClick={onClick}
    >
      <img src={image} alt="" width="100%" height="80px" />
      <p className="text-center py-2 font-s-20 font-w-500">{label}</p>
      {isSelected && (
        <div className="d-flex justify-content-center">
          <img src={TickIcon} alt="Tick" />
        </div>
      )}
    </div>
  );
};

export default RegistrationCard;
